import { render, staticRenderFns } from "./GarageDoorDamageSeverity.vue?vue&type=template&id=6b885db2&scoped=true"
import script from "./GarageDoorDamageSeverity.vue?vue&type=script&lang=ts"
export * from "./GarageDoorDamageSeverity.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b885db2",
  null
  
)

export default component.exports